import axios from 'axios'
import alertsMixin from './alerts-mixin'
import exceptionHandler from '@/common/exception-handler'

export const exceptionMixin = {
  mixins: [alertsMixin],
  methods: {
    handleError (error, message) {
      if (axios.isCancel(error)) {
        return
      }
      if (error && error[0] && error[0].code) {
        switch (error[0].code) {
          case 'CONFLICTING EDIT':
            message = 'A more recent menu has been detected. Please refresh the current menu to get latest version'
            break
        }
      }
      switch (error) {
        case 401:
          this.$store.commit('login/SET_USER', null)
          this.$router.push({ name: 'login' }).catch(() => {})
          break
        case 403:
          this.alertError('You are not authorized to perform the requested action.')
          this.$router.push({ name: 'home', query: { getStatus: true } }).catch(() => {})
          break
        default:
          console.error(error)
          this.alertError(message)
      }
    },
    isUserError (error) {
      return exceptionHandler.isUserError(error)
    },
    containsCode (error, code) {
      return exceptionHandler.containsCode(error, code)
    }
  }
}

export default exceptionMixin
